module.exports = __webpack_public_path__ + "static/media/disc.6975b716.svg";